import React, { createContext, useContext, useState, useEffect } from 'react';

const SportConfigContext = createContext(null);

// Sensible tennis fallback so the app renders even if the /config fetch fails
const TENNIS_FALLBACK = {
  sport:    'tennis',
  appName:  'Fantastic Tennis',
  appEmoji: '🎾',
  tours: [
    { id: 'ATP', label: 'ATP' },
    { id: 'WTA', label: 'WTA' },
  ],
  scoring: {
    model:  'rounds-won',
    rounds: ['R1', 'R2', 'R3', 'R4', 'QF', 'SF', 'F'],
  },
  landing: {
    heroTitle:       'Fantastic Tennis League',
    heroDescription: 'Join the ultimate fantasy tennis experience.',
    ctaText:         'Start drafting today and compete in the ultimate fantasy tennis league.',
    features:        [],
    scoringTitle:    'Scoring System',
    scoringSubtitle: 'Points awarded per round won — every win counts from the first match:',
  },
};

export function SportConfigProvider({ children }) {
  const [config, setConfig] = useState(null);
  const API_URL = process.env.REACT_APP_API_URL || '/api';

  useEffect(() => {
    fetch(`${API_URL}/config`)
      .then(r => r.json())
      .then(data => {
        if (data.success) {
          setConfig(data.config);
          // Update the document title to match the sport
          document.title = data.config.appName;
        } else {
          setConfig(TENNIS_FALLBACK);
        }
      })
      .catch(() => setConfig(TENNIS_FALLBACK));
  }, [API_URL]);

  return (
    <SportConfigContext.Provider value={config}>
      {children}
    </SportConfigContext.Provider>
  );
}

/**
 * Returns the sport config object, or null while still loading.
 * Components should guard against null where necessary.
 */
export function useSportConfig() {
  return useContext(SportConfigContext);
}
